import type { TaskBusiness } from "./business";

export const submissionLabels: Record<string, string> = {
  assigned: "已领取", submitted: "待审核", approved: "已通过",
  rejected: "已驳回", expired: "已过期", cancelled: "已取消", settled: "已结算",
};
export interface SubmissionFilters {
  task_id?: number;
  assignment_id?: number;
  status?: string;
  member_alias?: string;
  from?: string;
  to?: string;
}
export function submissionFiltersFromSearch(params: URLSearchParams, taskId?: number): SubmissionFilters {
  const positiveId = (key: string) => {
    const value = Number(params.get(key));
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
  };
  return {
    task_id: taskId ? undefined : positiveId("task_id"),
    assignment_id: positiveId("assignment_id"),
  };
}
export function submissionViewKey(params: URLSearchParams, taskId?: number) {
  return JSON.stringify([taskId ?? null, submissionFiltersFromSearch(params, taskId)]);
}
export function submissionListPath(filters: SubmissionFilters, taskId: number | undefined, page: number, pageSize: number, business?: TaskBusiness) {
  const params = new URLSearchParams();
  Object.entries({ ...filters, business, task_id: taskId ? undefined : filters.task_id, page, page_size: pageSize }).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, String(value));
  });
  return `${taskId ? `/tasks/${taskId}/submissions` : "/submissions"}?${params}`;
}
export function submissionDetailPath(taskId: number, assignmentId: number, business?: TaskBusiness) {
  return submissionListPath({ assignment_id: assignmentId }, taskId, 1, 1, business);
}
export function submissionDetailRecord(items: Submission[], taskId: number, assignmentId: number) {
  return items.find((item) => item.portal_task_id === taskId && item.assignment_id === assignmentId);
}
export interface Submission {
  submission_no: string;
  assignment_id: number;
  portal_task_id: number;
  task_title: string;
  task_type: string;
  member_alias: string;
  status: string;
  claimed_at: string;
  submitted_at: string | null;
  reviewed_at: string | null;
  rejection_reason: string;
}
// The selected end day is inclusive in the UI; the API upper bound is exclusive.
// Construct the China day explicitly, independently of the browser timezone.
export function chinaSubmissionRange(start: string, end: string) {
  const valid = (value: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const stamp = Date.parse(`${value}T00:00:00Z`);
    return Number.isFinite(stamp) && new Date(stamp).toISOString().slice(0, 10) === value;
  };
  if (!valid(start) || !valid(end) || start > end) throw new Error("请选择有效的提交日期范围");
  const next = new Date(Date.parse(`${end}T00:00:00Z`) + 86400000).toISOString().slice(0, 10);
  return { from: `${start}T00:00:00+08:00`, to: `${next}T00:00:00+08:00` };
}
